var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataList && _vm.dataList.length)?_c('div',{staticClass:"guess-comp"},[_c('ul',_vm._l((_vm.dataList),function(item,index){return _c('li',{key:index},[_c('span',{staticClass:"li-title"},[_vm._v(_vm._s(index + 1)+"：")]),_c('span',{staticClass:"li-content"},[_vm._v(_vm._s(item))])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }